export default __webpack_public_path__ + "static/media/Commander's Vambraces of the Battlements.edef29c5.jpg";